import { Component, inject } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { MapOrg, MapOrgRole, UrlPattern } from '@models';

@Component({
  selector: 'app-map-archive-org-form',
  templateUrl: './organisations.component.html',
  styleUrls: ['./organisations.component.scss'],
  imports: [
    KeyValuePipe,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
})
export class MapArchiveOrgFormComponent {
  dialogRef = inject<MatDialogRef<MapArchiveOrgFormComponent>>(MatDialogRef);

  public orgForm: FormGroup;

  public name: FormControl;
  public url: FormControl;
  public roles: FormControl;

  // Archive info

  public copies: FormControl;
  public room: FormControl;
  public storageRef: FormControl;

  public orgRoles = MapOrgRole;

  constructor() {
    const org = inject<MapOrg>(MAT_DIALOG_DATA);

    this.name = new FormControl(org?.name, {
      validators: [Validators.required],
    });
    this.url = new FormControl(org?.url, {
      validators: [Validators.pattern(UrlPattern)],
    });
    this.roles = new FormControl(org?.roles, {
      validators: [Validators.required],
    });

    this.copies = new FormControl(org?.archiveInfo?.copies || 1, {});
    this.room = new FormControl(org?.archiveInfo?.room, {});
    this.storageRef = new FormControl(org?.archiveInfo?.storageRef, {});

    this.orgForm = new FormGroup({
      name: this.name,
      url: this.url,
      roles: this.roles,
      copies: this.copies,
      room: this.room,
      storageRef: this.storageRef,
    });
  }

  submit() {
    if (this.orgForm.pristine || !this.orgForm.valid) {
      return;
    }

    if (this.orgForm.value.roles?.includes(this.orgRoles['Archive'])) {
      const formData = {
        name: this.orgForm.value.name,
        url: this.orgForm.value.url,
        roles: this.orgForm.value.roles,
        archiveInfo: {
          copies: this.orgForm.value.copies,
          room: this.orgForm.value.room,
          storageRef: this.orgForm.value.storageRef,
        },
      };

      this.dialogRef.close(formData);
      return;
    }

    const formData = {
      name: this.orgForm.value.name,
      url: this.orgForm.value.url,
      roles: this.orgForm.value.roles,
    };

    this.dialogRef.close(formData);
  }

  cancel() {
    this.dialogRef.close();
  }
}
